import React from 'react';
import { Outlet } from 'react-router-dom';
import { GlobalSearchShortcutProvider } from './context';

/**
 * Wrapper component to add around each route
 * This ensures the ShortcutListener is within the Router context
 */
const RouteWrapper: React.FC = () => {
  return (
    <GlobalSearchShortcutProvider>
      <Outlet />
    </GlobalSearchShortcutProvider>
  );
};

export default RouteWrapper;